module.exports = __webpack_public_path__ + "media/styles/images/svg/pencil-gray-fbeefbb8ebc05fb7804b7f92f015c4bc.svg";